'use es6';

import { Component } from 'react';
import PropTypes from 'prop-types';
import formatFraction from '../utils/formatFraction';
import { I18nHMRContext } from '../internal/i18n-internal';
import { jsx as _jsx } from "react/jsx-runtime";
export default class FormattedFraction extends Component {
  render() {
    const {
      numerator,
      denominator
    } = this.props;
    return /*#__PURE__*/_jsx("span", {
      children: formatFraction({
        numerator,
        denominator
      })
    });
  }
}
FormattedFraction.displayName = 'FormattedFraction';
FormattedFraction.contextType = I18nHMRContext;
FormattedFraction.propTypes = {
  numerator: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  denominator: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
};